import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ErrorService } from '@portal-core/errors/services/error.service';
import { Publication } from '@portal-core/publications/models/publication.model';
import { PublicationsService } from '@portal-core/publications/services/publications.service';
import { SnackBarAutoDismissDurationMS } from '@portal-core/ui/snack-bar/constants/snack-bar-auto-dismiss-duration.constant';
import { LoadingState } from '@portal-core/util/loading-state';

@Component({
  selector: 'mc-publication-deletion-form',
  templateUrl: './publication-deletion-form.component.html',
  styleUrls: ['./publication-deletion-form.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PublicationDeletionFormComponent {
  @Input() publication: Publication;
  @Output() cancel: EventEmitter<void> = new EventEmitter<void>();
  @Output() deleted: EventEmitter<void> = new EventEmitter<void>();

  savingState: LoadingState<string> = new LoadingState<string>();

  constructor(private snackBar: MatSnackBar, private errorService: ErrorService, private publicationsService: PublicationsService) { }

  onCancelClicked() {
    this.cancel.emit();
  }

  onSubmit() {
    this.savingState.update(true);

    this.publicationsService.bulkDeletePublications$(this.publication.ProjectId, [this.publication.Id]).subscribe(() => {
      this.savingState.update(false);
      this.snackBar.open('The publication has been deleted.', 'OK', { duration: SnackBarAutoDismissDurationMS });
      this.deleted.emit();
    }, error => {
      this.savingState.update(false, 'Unable to delete the publication.', this.errorService.getErrorMessages(error));
    });
  }
}
